<template>
  <div>
    <h2 style="text-align: center">Progress</h2>
    <div class="progress">
      <div class="progress--completed" :style="{width: percent + '%'}"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["percent"]
}
</script>

<style lang="less" scoped>
h2 {
  letter-spacing: 1px;
  text-transform: none;
}
.progress {
  bottom: 10px;
  width: 100%;
  height: 2em;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 20px;

  &--completed {
    background-color: white;
    border-radius: 20px;
    height: 2em;
  }
}
</style>
